<template>
    <div>
        <LoadingSpinner v-if="isLoading" message="Loading data..." />
        <div v-else>
      

            <div id="page-wrapper">
        
            
            
                <!-- Header --> 
				<section id="highlights" class="wrapper style3" style="margin-top: 50px !important;">

                    <div class="title"><img src="/main_asset/v2/images/Linc-impex.png" alt="Linc Impex" style="max-width: 100% !important;max-height: 100% !important;" /> Linc Impex</div>

                    <div class="container">

                        <div class="row aln-center">

							<div class="col-12 col-12-medium">

                                <section class="highlight">

                                    <form @submit.prevent="submitData" method="POST">

                                        <div class="mb-3">

                                            <p for="exampleFormControlInput1" style="text-align: left !important;"> {{ $t("descBeriPeringkat") }} </p>

                                            <table class="table table-striped">

                                                <tr>
                                                    <td style="text-align: left;"> {{ $t("cmlCustomerServiceHeader") }} </td>
                                                    <td> 

                                                        <select
                                                            class="form-select"
                                                            v-model="detailsForm.question_1"
                                                            @change="changeSelect($event, 1)"
                                                            :class="{ 'is-invalid': errors.question_1 }"
                                                            required
                                                            >
                                                            <option selected value="">-- {{ $t("pleaseSelect") }} --</option>
                                                            <option
                                                                v-for="o in options"
                                                                :value="o.name"
                                                                :key="o.name"
                                                                :disabled="o.disabled"
                                                            >
                                                                {{ o.name }}
                                                            </option>
                                                        </select>

                                                        <div v-if="errors.question_1">
                                                            <div class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ errors.question_1[0] }}
                                                            </div>
                                                        </div>

                                                    </td> 
                                                </tr>

                                                <tr>
                                                    <td style="text-align: left;"> {{ $t("cmlOperationalHeader") }} </td>
                                                    <td> 
                                                        
                                                        <select
                                                            class="form-select"
                                                            v-model="detailsForm.question_2"
                                                            @change="changeSelect($event, 2)"
                                                            :class="{ 'is-invalid': errors.question_2 }"
                                                            required
                                                            >
                                                            <option selected value="">-- {{ $t("pleaseSelect") }} --</option>
                                                            <option
                                                                v-for="o in options"
                                                                :value="o.name"
                                                                :key="o.name"
                                                                :disabled="o.disabled"
                                                            >
                                                                {{ o.name }}
                                                            </option>
                                                        </select>

                                                        <div v-if="errors.question_2">
                                                            <div class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ errors.question_2[0] }}
                                                            </div>
                                                        </div>

                                                    </td> 
                                                </tr>

                                                <tr>
                                                    <td style="text-align: left;"> {{ $t("cmlCompetitivenessHeader") }} </td>
                                                    <td> 
                                                        
                                                        <select
                                                            class="form-select"
                                                            v-model="detailsForm.question_3"
                                                            @change="changeSelect($event, 3)"
                                                            :class="{ 'is-invalid': errors.question_3 }"
                                                            required
                                                            >
                                                            <option selected value="">-- {{ $t("pleaseSelect") }} --</option>
                                                            <option
                                                                v-for="o in options"
                                                                :value="o.name"
                                                                :key="o.name"
                                                                :disabled="o.disabled"
                                                            >
                                                                {{ o.name }}
                                                            </option>
                                                        </select>

                                                        <div v-if="errors.question_3">
                                                            <div class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ errors.question_3[0] }}
                                                            </div>
                                                        </div>

                                                    </td> 
                                                </tr>

                                                <tr>
                                                    <td style="text-align: left;"> {{ $t("cmlTechnicalSupportHeader") }} </td>
                                                    <td> 
                                                        
                                                        <select
                                                            class="form-select"
                                                            v-model="detailsForm.question_4"
                                                            @change="changeSelect($event, 4)"
                                                            :class="{ 'is-invalid': errors.question_4 }"
                                                            required
                                                            >
                                                            <option selected value="">-- {{ $t("pleaseSelect") }} --</option>
                                                            <option
                                                                v-for="o in options"
                                                                :value="o.name"
                                                                :key="o.name"
                                                                :disabled="o.disabled"
                                                            >
                                                                {{ o.name }}
                                                            </option>
                                                        </select>

                                                        <div v-if="errors.question_4">
                                                            <div class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ errors.question_4[0] }}
                                                            </div>
                                                        </div>


                                                    </td> 
                                                </tr>

                                                <tr>
                                                    <td style="text-align: left;"> {{ $t("cmlComplianceHeader") }} </td>
                                                    <td> 
                                                        
                                                        <select
                                                            class="form-select"
                                                            v-model="detailsForm.question_5"
                                                            @change="changeSelect($event, 5)"
                                                            :class="{ 'is-invalid': errors.question_5 }"
                                                            required
                                                            >
                                                            <option selected value="">-- {{ $t("pleaseSelect") }} --</option>
                                                            <option
                                                                v-for="o in options"
                                                                :value="o.name"
                                                                :key="o.name"
                                                                :disabled="o.disabled"
                                                            >
                                                                {{ o.name }}
                                                            </option>
                                                        </select>

                                                        <div v-if="errors.question_5">
                                                            <div class="alert alert-primary" role="alert">
                                                                <i data-feather="alert-circle"></i>
                                                                {{ errors.question_5[0] }}
                                                            </div>
                                                        </div>

                                                    </td> 
                                                </tr>

                                            </table>
    

                                        </div>



                                        <div class="mb-3">

                                            <p for="exampleFormControlInput1" style="text-align: left !important;"> {{ $t("aspekBerikut") }} </p>
                                            <div class="table-responsive">
                                                <table class="table" border="0">
                                                    <thead>
                                                        <tr>
                                                        <th scope="col" class="col-6"></th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("definition") }} </th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("answerOption5") }} </th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("answerOption4") }} </th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("answerOption3") }} </th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("answerOption2") }} </th>
                                                        <th scope="col" class="col-1" style="text-align: center;"> {{ $t("answerOption1") }} </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        <tr>
                                                            <td colspan="7" style="text-align: left;"><b>1. {{ $t("cmlCustomerServiceHeader") }} </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">1.1 {{ $t("cmlCustomerServiceSub1") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definition1()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_6" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_6" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_6" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_6" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_6" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">1.2 {{ $t("cmlCustomerServiceSub2") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definition2()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_7" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_7" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_7" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_7" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_7" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">1.3 {{ $t("cmlCustomerServiceSub3") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definition3()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_8" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_8" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_8" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_8" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_8" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">1.4 {{ $t("cmlCustomerServiceSub4") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definition4()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_9" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_9" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_9" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_9" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_9" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colspan="7" style="text-align: left;"><b>2. {{ $t("cmlOperationalHeader") }} </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">2.1 {{ $t("impexOperationalSub1") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionOperational1()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_10" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_10" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_10" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_10" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_10" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">2.2 {{ $t("impexOperationalSub2") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionOperational2()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_11" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_11" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_11" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_11" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_11" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">2.3 {{ $t("impexOperationalSub3") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionOperational3()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_12" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_12" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_12" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_12" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_12" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">2.4 {{ $t("impexOperationalSub4") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionOperational4()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_13" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_13" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_13" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_13" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_13" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colspan="7" style="text-align: left;"><b>3. {{ $t("cmlCompetitivenessHeader") }} </b></td>
                                                        </tr>        

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">3.1 {{ $t("expressCompetitivenessSub1") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionCompetitiveness1()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_14" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_14" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_14" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_14" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_14" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">3.2 {{ $t("cmlCompetitivenessSub2") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionCompetitiveness2()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_15" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_15" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_15" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_15" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_15" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">3.3 {{ $t("expressCompetitivenessSub3") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionCompetitiveness3()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_16" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_16" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_16" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_16" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_16" value="5">
                                                            </td>
                                                        </tr>


                                                        <tr>
                                                            <td colspan="7" style="text-align: left;"><b>4. {{ $t("cmlTechnicalSupportHeader") }} </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">4.1 {{ $t("expressTechnicalSupportSub1") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionTechnicalSupport1()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_17" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_17" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_17" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_17" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_17" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">4.2 {{ $t("expressTechnicalSupportSub2") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionTechnicalSupport2()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_18" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_18" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_18" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_18" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_18" value="5">
                                                            </td>
                                                        </tr>
 

                                                        <tr>
                                                            <td colspan="7" style="text-align: left;"><b>5. {{ $t("cmlComplianceHeader") }} </b></td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">5.1 {{ $t("cmlComplianceSub1") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionCompliance1()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_19" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_19" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_19" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_19" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_19" value="5">
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style="text-align: left; padding-left: 3%;">5.2 {{ $t("cmlComplianceSub2") }}</td>
                                                            <td style="text-align: center;">
                                                                <a hef="#" :title="$t('definition')" @click.prevent="definitionCompliance2()" ref="btnShow"> <i class="bi bi-eye"></i> </a>
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_20" value="2.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_20" value="3"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_20" value="3.5"> 
                                                            </td> 
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_20" value="4.5"> 
                                                            </td>
                                                            <td style="text-align: center;">
                                                                <input class="form-check-input" type="radio" v-model="detailsForm.question_20" value="5">
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>

                                        <div class="mb-3">

                                            <div class="col-12" style="text-align:left;">
                                                <ul class="actions">
                                                    <li><input type="submit" class="style1" :value="$t('nextPage')" /></li>
                                                </ul>
                                            </div>

                                        </div>

                                    </form>

                                </section>

                            </div>

                        </div>

                    </div>


                </section>
 
 <transition name="modal">
				<div class="modal-mask" v-if="showModal">
					<MyComponentModal :postsModal="postsModal" @close="closeModal"/>
				</div>
			</transition>



            </div>
            

        </div>
    </div>


</template>


<script>

import LoadingSpinner from './LoadingSpinner.vue';
import MyComponentModal from './MyComponentModal.vue'

export default {

    name: "SurveyLincImpex",
    components: {
        LoadingSpinner,
        MyComponentModal
    },

    props: {

        locales: String,

    },

    data() {
    return {
        postsModal:{},
        showModal: false,
        isLoading:true,
        errors:[],
        forms: {
            customer_name:"",
            customer_departement:"",
            customer_email:"",
            customer_company:"",
            linc_logistics:0,
            linc_express:0,
            linc_impex:0,
            linc_terminal:0,
            merekomendasikan_linc:1,
            kesan_dengan_linc:"",
            hal_yang_perlu_ditingkatkan:"",
            years:"",
        },
        detailsForm:{

            type :'LincImpex',
            question_1:'',
            question_2:'',
            question_3:'',
            question_4:'',
            question_5:'',
            question_6:5,
            question_7:5,
            question_8:5,
            question_9:5,
            question_10:5,
            question_11:5,
            question_12:5,
            question_13:5,
            question_14:5,
            question_15:5,
            question_16:5,
            question_17:5,
            question_18:5,
            question_19:5,
            question_20:5,
            question_21:5,
            question_22:5,
            question_23:5,
            question_24:0,
            
        },
        options: [
            { name: "5", disabled: false },
            { name: "4", disabled: false },
            { name: "3", disabled: false },
            { name: "2", disabled: false },
            { name: "1", disabled: false },
        ],
        details:[],
        langs: [
            {
            name:"Indonesia",
            value:"id"
            },
            {
            name:"English",
            value:"en"
            }
        ],
        selectedLang: "",
        locale: "",
        selectedQ1: [],
    };
    },

    computed: {
    
    },

    watch: {
        
        locales: {
            handler(newVal) {
                this.selectedLang = newVal;
            },
            immediate: true,
            deep: true,
        },

    },

    methods: {

        changeSelect(ev, field) {
            const index = ev.target.selectedIndex;
            const value = ev.target.value;
            if (value !== "") {
                this.options = this.options.map((o, i) => {
                // Disabled Selected Value
                if (i === index - 1) {
                    o.disabled = true;
                }

                // Assign Selected Value perfield
                this.selectedQ1[field] = value;

                // Recheck Disabled Item
                if (o.disabled) {
                    // Set Default False
                    var checked = false;
                    // Loop SelectedValue Data to Validate (if option disabled but not found in selected value set disabled to false)
                    this.selectedQ1.forEach((item) => {
                    if (o.name == item) {
                        checked = true;
                    }
                    });

                    o.disabled = checked;
                }

                return o;
                });
            } else {
                // Undisabled unselected item
                const removedField = this.selectedQ1[field];
                this.options = this.options.map((o) => {
                // If Option name = removed value => enable option
                if (o.name === removedField) {
                    o.disabled = false;
                }
                return o;
                });
                this.selectedQ1[field] = null;
            }
        },

        langChanged(lang) {
            this.locale       = lang;
            this.$i18n.locale = lang;
            localStorage.Lang = lang;
        },

        submitData(){
            this.errors = [];

            this.$swal({
                title: this.$t("areYouSure"),
                text: '',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                
                if (result.value) {

                    this.isLoading  = true;

                    var question = this.detailsForm;

                    if (question.question_1 === '' || question.question_1 === null || typeof question.question_1 === 'undefined') {

                        this.errors.question_1 = [ this.$t("question_1tWajibIsi") ];
                        
                        this.error( this.$t("question_1tWajibIsi") );
                        
                    }

                    if (question.question_2 === '' || question.question_2 === null || typeof question.question_2 === 'undefined') {

                        this.errors.question_2 = [ this.$t("question_2tWajibIsi") ];
                        
                        this.error( this.$t("question_2tWajibIsi") );
                        
                    }

                    if (question.question_3 === '' || question.question_3 === null || typeof question.question_3 === 'undefined') {

                        this.errors.question_3 = [ this.$t("question_3tWajibIsi") ];
                        
                        this.error( this.$t("question_3tWajibIsi") );
                        
                    }

                    if (question.question_4 === '' || question.question_4 === null || typeof question.question_4 === 'undefined') {

                        this.errors.question_4 = [ this.$t("question_4tWajibIsi") ];
                        
                        this.error( this.$t("question_4tWajibIsi") );
                        
                    }

                    if (question.question_5 === '' || question.question_5 === null || typeof question.question_5 === 'undefined') {

                        this.errors.question_5 = [ this.$t("question_5tWajibIsi") ];
                        
                        this.error( this.$t("question_5tWajibIsi") );
                        
                    }

                    

                     
                    localStorage.setItem("questionId", this.$route.params.id);
                    this.details.push(this.detailsForm);
                    let dummyDetails = JSON.stringify(this.details);
                    localStorage.setItem("formDataDetails", dummyDetails);

                                       
                
                   if (this.forms.linc_terminal) {

                        window.location.href = '/survey-linc-terminal/' + this.$route.params.id;

                    }else{

                        window.location.href = '/survey-last/' + this.$route.params.id;

                    }
                    
                    
                    

                    this.isLoading  = false;


                }

            });

        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
                }
            }
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        loadData() {
            
            if (localStorage.getItem("questionId") !== null) {

                if (localStorage.getItem("questionId") == this.$route.params.id) {

                    if (localStorage.getItem("formDataHeader") !== null) {

                        let dummy = JSON.parse(localStorage.getItem("formDataHeader"));
                        let dummyDetails = JSON.parse(localStorage.getItem("formDataDetails"));
                        this.forms = dummy;
                        if(!dummy.linc_impex){

                            localStorage.removeItem("questionId");
                            localStorage.removeItem("formData");
                            this.isLoading  = false;
                            window.location.href = '/survey/' + this.$route.params.id;

                        }
                        this.details = dummyDetails;
                        this.isLoading  = false;

                        // console.log(this.forms)

                        // console.log(this.forms)

                    }else{

                        localStorage.removeItem("questionId");
                        localStorage.removeItem("formData");
                        this.isLoading  = false;
                        window.location.href = '/survey/' + this.$route.params.id;

                    }

                } else {

                    localStorage.removeItem("questionId");
                    localStorage.removeItem("formData");
                    this.isLoading  = false;
                    window.location.href = '/survey/' + this.$route.params.id;

                }

            }else{

                this.isLoading  = false;
                window.location.href = '/survey/' + this.$route.params.id;

            }

        },

        definition1(){

            this.postsModal = {
                title : this.$t("cmlCustomerServiceHeader")+`<br>`+this.$t("cmlCustomerServiceSub1") ,
                body : this.$t("definitionImpex1") ,
            }
           this.showModal = true;

        }, 

        definition2(){

            this.postsModal = {
                title : this.$t("cmlCustomerServiceHeader")+`<br>`+this.$t("cmlCustomerServiceSub2") ,
                body : this.$t("definitionImpex2") ,
            }
           this.showModal = true;

        }, 

        definition3(){

            this.postsModal = {
                title : this.$t("cmlCustomerServiceHeader")+`<br>`+this.$t("cmlCustomerServiceSub3") ,
                body : this.$t("definitionImpex3") ,
            }
           this.showModal = true;

        }, 

        definition4(){

            this.postsModal = {
                title : this.$t("cmlCustomerServiceHeader")+`<br>`+this.$t("cmlCustomerServiceSub4") ,
                body : this.$t("definitionImpex4") ,
            }
           this.showModal = true;

        },


        definitionOperational1(){

            this.postsModal = {
                title : this.$t("cmlOperationalHeader")+`<br>`+this.$t("impexOperationalSub1") ,
                body : this.$t("definitionOperationalImpex1") ,
            }
           this.showModal = true;

        }, 
        
        definitionOperational2(){

            this.postsModal = {
                title : this.$t("cmlOperationalHeader")+`<br>`+this.$t("impexOperationalSub2") ,
                body : this.$t("definitionOperationalImpex2") ,
            }
           this.showModal = true;

        }, 
        
        definitionOperational3(){

            this.postsModal = {
                title : this.$t("cmlOperationalHeader")+`<br>`+this.$t("impexOperationalSub3") ,
                body : this.$t("definitionOperationalImpex3") ,
            }
           this.showModal = true;

        }, 
        
        definitionOperational4(){

            this.postsModal = {
                title : this.$t("cmlOperationalHeader")+`<br>`+this.$t("impexOperationalSub4") ,
                body : this.$t("definitionOperationalImpex4") ,
            }
           this.showModal = true;

        }, 
        
        definitionCompetitiveness1(){

            this.postsModal = {
                title : this.$t("cmlCompetitivenessHeader")+`<br>`+this.$t("expressCompetitivenessSub1") ,
                body : this.$t("definitionCompetitivenessImpex1") ,
            }
           this.showModal = true;

        }, 
        
        definitionCompetitiveness2(){

            this.postsModal = {
                title : this.$t("cmlCompetitivenessHeader")+`<br>`+this.$t("cmlCompetitivenessSub2") ,
                body : this.$t("definitionCompetitivenessImpex2") ,
            }
           this.showModal = true;

        }, 
        
        definitionCompetitiveness3(){

            this.postsModal = {
                title : this.$t("cmlCompetitivenessHeader")+`<br>`+this.$t("expressCompetitivenessSub3") ,
                body : this.$t("definitionCompetitivenessImpex3") ,
            }
           this.showModal = true;

        }, 
        
        definitionTechnicalSupport1(){

            this.postsModal = {
                title : this.$t("cmlTechnicalSupportHeader")+`<br>`+this.$t("expressTechnicalSupportSub1") ,
                body : this.$t("definitionTechnicalSupportImpex1") ,
            }
           this.showModal = true;

        }, 
        
        definitionTechnicalSupport2(){

            this.postsModal = {
                title : this.$t("cmlTechnicalSupportHeader")+`<br>`+this.$t("expressTechnicalSupportSub2") ,
                body : this.$t("definitionTechnicalSupportImpex2") ,
            }
           this.showModal = true;

        }, 
        
        
        definitionCompliance1(){

            this.postsModal = {
                title : this.$t("cmlComplianceHeader")+`<br>`+this.$t("cmlComplianceSub1") ,
                body : this.$t("definitionComplianceImpex1") ,
            }
           this.showModal = true;

        }, 
        
        definitionCompliance2(){

            this.postsModal = {
                title : this.$t("cmlComplianceHeader")+`<br>`+this.$t("cmlComplianceSub2") ,
                body : this.$t("definitionComplianceImpex2") ,
            }
           this.showModal = true;

        }, 
         
 
        closeModal(){
            this.postsModal = {},
			this.showModal = false;
		}
    

    },


    events: {

    },

    created: function () {
    
    },

    mounted() {
        
        this.loadData(); 

    },

    updated() {


    },

    onLoad(){


    }


}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
  text-align: center !important;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>